const productStickyBar = () => {
  document.addEventListener('click', function(e) {
    const target = e.target.closest('.sticky-email-button');
    if (target) {
      e.preventDefault();
      let emailBIS = document.getElementById("BIS_trigger");
      if(emailBIS) {
        emailBIS.click();
      }
    }
  });
};

productStickyBar();
